import {Plural} from '@lingui/macro';
import _ from 'lodash';
import React from 'react';

import {TableColumn} from '../../../../../../../../../src/components/common/table/tableColumn';
import {ContactsManagerCustomFieldColumnMetadata} from '../contactsManagerCustomFieldTypes';
import {SharedColumnsEnum} from '../sharedTableConfig';
import {
  contactsTableColumns,
  ContactsTableColumnsEnum,
  ContactsTableDefaultColumnsEnum,
} from './contactsTableConfig';

/*
 * Helpers.
 */

export function filterTableColumns(columnType: ContactsTableColumnsEnum) {
  return contactsTableColumns.filter((column) => column.type !== columnType);
}

export function getAllTableColumnsInOrder(
  dynamicColumns: ReadonlyArray<
    TableColumn<SharedColumnsEnum, ContactsManagerCustomFieldColumnMetadata | undefined>
  >,
  shouldHideAccountsColumn?: boolean,
) {
  const tableColumns = shouldHideAccountsColumn
    ? filterTableColumns(ContactsTableDefaultColumnsEnum.ACCOUNT)
    : [...contactsTableColumns];

  const [listsColumn, otherColumns] = _.partition(tableColumns, {
    type: ContactsTableDefaultColumnsEnum.LISTS,
  });
  const allTableColumns = [...otherColumns, ...dynamicColumns, ...listsColumn];
  return allTableColumns;
}

export function renderContactsTableMultiSelectCardCount(totalCards: number) {
  return (
    <Plural
      id="contact-manager-table-total-contacts-selected"
      value={totalCards}
      one="1 contact selected"
      other="# contacts selected"
    />
  );
}
